import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);
  const recentArticles = articles.filter((a) => !a.featured).slice(0, 4);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs tracking-widest uppercase text-accent-500 font-medium mb-3 whitespace-nowrap">Featured</p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            精选文章
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
            由喵绅士编辑团队精心策划的优质内容，为您呈现猫咪世界的无尽魅力
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-12">
          {featuredArticles.map((article, index) => (
            <ArticleCard key={article.slug} article={article} variant={index === 0 ? 'featured' : 'default'} />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {recentArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="compact" />
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12">
          <Link
            to="/category/cat-culture"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 rounded-full text-sm font-medium hover:bg-secondary-600 transition-all duration-300 whitespace-nowrap"
          >
            浏览全部文章
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>
      </div>
    </section>
  );
}